// Shared formatting helpers used across pages.

export function timeAgo(input) {
  if (input == null) return '—';
  const t = input instanceof Date ? input.getTime() : new Date(input).getTime();
  if (Number.isNaN(t)) return '—';
  const diff = Date.now() - t;
  if (diff < 60_000) return 'just now';
  const mins = Math.floor(diff / 60_000);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function formatCurrency(val, opts = {}) {
  const { currency = 'CAD', compact = true } = opts;
  const n = Number(val) || 0;
  if (compact) {
    if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
    if (Math.abs(n) >= 1_000)     return `$${(n / 1_000).toFixed(1)}K`;
    return `$${n.toFixed(2)}`;
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(n);
}

export const corridorMetadata = {
  CAD_KES: { name: 'Kenya',        flag: '🇰🇪', currency: 'KES' },
  CAD_NGN: { name: 'Nigeria',      flag: '🇳🇬', currency: 'NGN' },
  CAD_GHS: { name: 'Ghana',        flag: '🇬🇭', currency: 'GHS' },
  CAD_ZAR: { name: 'South Africa', flag: '🇿🇦', currency: 'ZAR' },
  CAD_UGX: { name: 'Uganda',       flag: '🇺🇬', currency: 'UGX' },
  CAD_TZS: { name: 'Tanzania',     flag: '🇹🇿', currency: 'TZS' },
};

export const networkMetadata = {
  base:    { name: 'Base',    short: 'BASE', chain_id: 8453 },
  polygon: { name: 'Polygon', short: 'POLY', chain_id: 137 },
  solana:  { name: 'Solana',  short: 'SOL',  chain_id: null },
};
